module.exports = __webpack_public_path__ + "static/img/Arishina-200x123.ee6b582a.jpg";